import { render, staticRenderFns } from "./OrderInvoice.vue?vue&type=template&id=09efc0ae&scoped=true"
import script from "./OrderInvoice.vue?vue&type=script&lang=js"
export * from "./OrderInvoice.vue?vue&type=script&lang=js"
import style0 from "./OrderInvoice.vue?vue&type=style&index=0&id=09efc0ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09efc0ae",
  null
  
)

export default component.exports